export class ChangePasswordRequest {

    OldPassword?: string;
    Password?: string;
    PasswordConfirm?: string;
    UserName?: string;
}